export default {
  "open": "Enlarge hole {number} image",
  "title": "{course} · Hole {number} image",
  "back": "Back to scoring",
  "hole": "Hole {number}",
  "description": "{course} · Hole {number}",
  "loading": "Loading image…",
  "error": "This image could not be loaded.",
  "retry": "Retry",
  "zoom": "Image zoom",
  "out": "Zoom out",
  "reset": "Reset zoom",
  "in": "Zoom in"
}
